var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyTask(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560.82 581.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7404;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.99,294.91c-10.01,12.36-15.65,28.78-15.65,47.96v3.57c-7.23-.04-14.93,.14-23.15,.48h-101.88c-110.96-4.65-128.57,22.04-124.48,146.86v87.45H0v-150.83c0-81.09,54.29-135.49,135.27-135.49h188.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    className: "cls-1",
    d: "M235.06,267.92c-74.19-.04-134.29-60.22-134.25-134.4,.03-53.93,32.31-102.61,81.98-123.63,68.74-27.89,147.08,5.23,174.97,73.97,27.34,67.38-3.9,144.27-70.48,173.5-16.52,7-34.28,10.59-52.22,10.56Zm0-208.9c-41.2,0-74.61,33.4-74.61,74.61s33.4,74.61,74.61,74.61,74.61-33.4,74.61-74.61c-.04-41.19-33.42-74.56-74.61-74.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M473.57,269.83h.01s0,0,0,0h-.01Zm87.23,85.14s.02,.02,.02,.02v-.02h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M544.68,294.91c-.13-.16-.25-.32-.38-.47-12.82-15.55-32.64-24.61-56.9-24.61h-106.13c-.21,0-.42,0-.63,.01-23.97,.15-43.56,9.19-56.27,24.6-.13,.15-.25,.31-.38,.47-10.01,12.36-15.65,28.78-15.65,47.96v165.32c0,43.71,29.27,73.04,72.93,73.04h106.13c43.66,0,72.93-29.33,72.93-73.04v-165.32c0-19.18-5.64-35.6-15.65-47.96Zm-59.78,258.16c-4.96,.36-10.45,.46-16.52,.33-2.21-.04-4.5-.11-6.87-.21h-54.35c-8.87,.37-16.62,.37-23.39-.12-38.98-2.8-45.59-21.73-43.71-79.04v-97c-.35-10.92-.41-20.46,.02-28.75,.02-.45,.04-.9,.07-1.35,.01-.16,.02-.31,.03-.47,.01-.16,.02-.31,.03-.46,1.83-28.85,9.93-41.99,31.91-46.48,3.52-.72,7.39-1.22,11.65-1.53,3.34-.24,6.95-.36,10.81-.37,3.93-.03,8.11,.06,12.58,.25h54.35c4.47-.19,8.65-.28,12.58-.25,3.86,.01,7.47,.13,10.81,.37,30.87,2.22,41.44,14.54,43.56,48.01,.01,.15,.02,.3,.03,.46,.01,.16,.02,.31,.03,.47,.51,8.6,.46,18.58,.09,30.1v97c1.88,57.31-4.73,76.24-43.71,79.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M560.8,354.97s.02,.02,.02,.02v-.02h-.02Zm-87.23-85.14h.01s0,0,0,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.98,251.92h81.05c6.26,0,11.34,4.48,11.34,10v9.36c0,5.52-5.08,10-11.34,10h-81.05c-6.26,0-11.34-4.48-11.34-10v-9.36c0-5.52,5.08-10,11.34-10Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 419.58,
    y: 347.77,
    width: 85.76,
    height: 29.36
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "401.39 351.55 375.81 377.13 363.31 364.64 367.6 360.35 375.81 368.55 397.1 347.26 401.39 351.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 419.58,
    y: 411.1,
    width: 85.76,
    height: 29.36
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "401.39 414.88 375.81 440.46 363.31 427.97 367.6 423.68 375.81 431.89 397.1 410.6 401.39 414.88"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 419.58,
    y: 474.44,
    width: 85.76,
    height: 29.36
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "401.39 478.22 375.81 503.8 363.31 491.31 367.6 487.01 375.81 495.22 397.1 473.93 401.39 478.22"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTask);
export default __webpack_public_path__ + "static/media/myTask.89ee131a3200b3e39b9848a05ab68148.svg";
export { ForwardRef as ReactComponent };